/* TIMELESS MOONLIGHT MELTS — crop grid descriptions to 10 words.

   Milano renders custom.short_description in full inside every product card,
   which makes grid rows ragged when some scents have three lines of notes and
   others have one. This trims each to 10 words followed by an ellipsis.

   Done in JS rather than Liquid so snippets/product-item.liquid stays stock —
   it is one of the files most likely to change in a Milano update. The CSS in
   tmm-cards.css line-clamps the same element to two lines, so nothing jumps
   between first paint and this running.

   The original text is kept in data-tmm-full, so this is reversible and can
   never crop an already-cropped string.
*/
(function () {
  var LIMIT = 10;
  var SELECTOR = '.product-item__short-description';
  var scheduled = false;

  function crop(el) {
    if (el.getAttribute('data-tmm-cropped') === '1') return;

    var full = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!full) return;

    el.setAttribute('data-tmm-full', full);
    el.setAttribute('data-tmm-cropped', '1');

    var words = full.split(' ');
    if (words.length <= LIMIT) {
      el.textContent = full;
      return;
    }

    /* Drop any trailing punctuation on the last kept word so we don't end up
       with "cedar.…" or "vanilla,…". */
    var kept = words.slice(0, LIMIT).join(' ').replace(/[\s,;:.–—-]+$/, '');
    el.textContent = kept + '…';
    el.setAttribute('title', full);
  }

  function scan() {
    scheduled = false;
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) crop(nodes[i]);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(scan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* Carousels, filtered collections, quick view and infinite scroll all inject
     fresh cards after load, so keep watching. */
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
